/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  //Chip,
  Avatar,
  Skeleton,
} from '@mui/material';
import {
  getDoctors,
  //getEffectiveDoctorAvailability,
} from '../services/api_service';
import PersonIcon from '@mui/icons-material/Person';
//import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import DoctorAvailabilityCalendar from '../components/DoctorAvailabilityCalendar';
import { useAlert } from '../AlertContext';

export default function DoctorAvailabilityOverview() {
  const [doctors, setDoctors] = useState([]);
  // No longer need availability and exceptions state here, as we'll fetch effective availability day-by-day in the calendar component
  const [selectedDoctor, setSelectedDoctor] = useState('all');
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlert();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const doctorsResponse = await getDoctors(); // Only fetch doctors here

      if (doctorsResponse?.result) {
        setDoctors(doctorsResponse.result);
      }
    } catch (error) {
      showAlert('Error al cargar los datos', 'error');
    } finally {
      setLoading(false);
    }
  };

  const getFilteredDoctors = () => {
    if (selectedDoctor === 'all') {
      return doctors;
    }
    return doctors.filter((doctor) => doctor.id === selectedDoctor);
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Skeleton
            variant="text"
            width={400}
            height={60}
            sx={{ mx: 'auto' }}
          />
          <Skeleton
            variant="text"
            width={250}
            height={30}
            sx={{ mx: 'auto' }}
          />
        </Box>
        <Grid container spacing={3}>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} key={item}>
              <Skeleton variant="rectangular" height={200} />
            </Grid>
          ))}
        </Grid>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 3, mb: 3, pb: 3 }}>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Vista General de Disponibilidad
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Visualiza los horarios de todos los doctores
        </Typography>
      </Box>

      {/* Doctor Filter */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <FormControl sx={{ minWidth: 300 }}>
            <InputLabel>Filtrar por Doctor</InputLabel>
            <Select
              value={selectedDoctor}
              label="Filtrar por Doctor"
              onChange={(e) => setSelectedDoctor(e.target.value)}
            >
              <MenuItem value="all">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Avatar sx={{ width: 24, height: 24, bgcolor: 'grey.400' }}>
                    <MedicalServicesIcon sx={{ fontSize: 14 }} />
                  </Avatar>
                  <Typography>Todos los Doctores</Typography>
                </Box>
              </MenuItem>
              {doctors.map((doctor) => (
                <MenuItem key={doctor.id} value={doctor.id}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar
                      sx={{ width: 24, height: 24, bgcolor: 'primary.main' }}
                    >
                      <PersonIcon sx={{ fontSize: 14 }} />
                    </Avatar>
                    <Typography>{doctor.name}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </CardContent>
      </Card>

      {/* Doctor Availability Calendars */}
      {getFilteredDoctors().length === 0 ? (
        <Card sx={{ textAlign: 'center', p: 3 }}>
          <MedicalServicesIcon
            sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }}
          />
          <Typography variant="h6" color="text.secondary">
            No hay doctores registrados
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Primero debes registrar doctores para ver su disponibilidad
          </Typography>
        </Card>
      ) : (
        getFilteredDoctors().map((doctor) => (
          <DoctorAvailabilityCalendar
            key={doctor.id}
            doctorId={doctor.id} // Pass doctorId
            doctorName={doctor.name}
            // effectiveAvailability will be fetched inside the calendar component
          />
        ))
      )}
    </Container>
  );
}
